//Javascript for the WECAN Employer Area Signup functionality
app.EmployerVacancy = (
    function () {
        var vacancy = {
            Edit: function () {
                $("#duplicateVacancyWarningButton").on("click", function () {
                    
                    $("#confirmExtendCloseDateDuplicate").modal("hide");
                    $("#confirmDuplicateVacancy").modal("show");

                });

                $("[data-clear-licenses]").on("click keyup", function () {
                    //Get the target
                    clearLicenseList("[data-clear-licenses]");
                  
                });

                //listen for is license exempt checkbox and disable fields as necessary
                $("[name='IsExceptLicenseRequirement'").on("change", function () {
                    if ($(this).prop("checked")) {
                        $("#license-row").hide();
                        clearLicenseList("[data-clear-licenses]");
                    } else {
                        $("#license-row").show();
                    }
                });
                $('[data-role="toggle-title-options"]').on('click', function () {
                    $('[data-role="option-containter"]').hide();
                    $('[data-target="' + $(this).data('target') + '"]').show();
                });

                $('[data-role~="close-date"], input[type="checkbox"][data-role~="apply-after-end"]').on('change', function () {
                    if ($(this).data('extend-protection').toString().toLowerCase() === "true") {
                        $('#confirmExtendCloseDateDuplicate').modal("show");
                    }
                });

                $('[data-role~="datepicker"]').on('change blur', function () {
                    $(this).valid();
                });

                $('[data-role~="title-options"]').on('change', function () {
                    //update all the fields
                    app.Page.selectedOptionId = $(this).val();
                    if (($('[Name="Title"]').val() != null && $('[Name="Title"]').val().trim().length)
                        || ($('[Name="Location"]').val() != null && $('[Name="Location"]').val().trim().length)
                        || ($('[Name="Url"]').val() != null && $('[Name="Url"]').val().trim().length)
                        || ($('[Name="AdditionalQuestionSetId"]').val() != null && $('[Name="AdditionalQuestionSetId"]').val().trim().length)) {
                        //show modal popup if there is a valid selected option
                        if (app.Page.selectedOptionId !== null && app.Page.selectedOptionId !== "") {
                            $('#confirmTitleOption').modal("show");
                        }
                    }
                    else {
                        SetVacancyFields();
                    }
                });

                $('[data-role="other-toggle"]').on('change', function () {
                    //if the option selected is the same as the other option, show toggle target, otherwise hide
                    if ($(this).data("other-option-unique-id") === $('option:selected', this).data('unique-id')) {
                        $('[data-target="' + $(this).data('other-toggle-target') + '"]').show();
                    }
                    else {
                        $('[data-target="' + $(this).data('other-toggle-target') + '"]').hide();
                        $('input[type="text"]', '[data-target="' + $(this).data('other-toggle-target') + '"]').val('');
                    }
                });

                // events for save and return/save and preview buttons
                $("#btnSaveAndStay").on("click",
                    function () {
                        var form = $("#vacancyForm");
                        $("#SubmitType").val(1);
                        form.submit();
                    });

                $("#btnSaveAndReturn").on("click",
                    function () {
                        var form = $("#vacancyForm");
                        $("#SubmitType").val(2);
                        form.submit();
                    });

                $("#btnSaveAndPreview").on("click",
                    function () {
                        var form = $("#vacancyForm");
                        $("#SubmitType").val(3);
                        form.submit();
                    });
                $('input[name="VacancyCloseDate"], input[name="CanApplyAfterEndDate"]').change(function () {
                    if ($('input[name="IsClosedStatus"]').val().toLowerCase() === 'true') {
                        //// Show the modal
                        //$('#closedVacancyMessage').modal('show');
                    }
                });

                //////
                //Functionality that does not need to be reset every duplicate
                $('#vacancyForm').dirty({
                    preventLeaving: true,
                    leavingMessage: 'There are unsaved changes on this page which will be discarded if you continue.'
                });

                $('[data-role="confirm-title-option"]').on('click', function () {
                    SetVacancyFields();
                    $('#confirmTitleOption').modal("hide");
                    //REINIT JS
                    app.Page.selectedOptionId = null;
                });


                function SetVacancyFields() {
                    // make sure the selected option is valid (not blank)
                    if (app.Page.selectedOptionId !== null && app.Page.selectedOptionId !== "") {
                        $('[data-role="edit-form-container"]').closest('form').hide();
                        $('[data-role="edit-form-container"]').closest('.card').addClass('loading-placeholder');
                        //ajax to get the new view returned by
                        $.post($('[data-role="confirm-title-option"]').data('url'), { id: app.page.id, duplicateId: app.Page.selectedOptionId })
                            .done(function (view) {
                                //replace form with new one
                                $('[data-role="edit-form-container"]').html(view);
                            }).always(function () {
                                $('[data-role="edit-form-container"]').closest('.card').removeClass('loading-placeholder');
                                $('[data-role="edit-form-container"]').closest('form').show();
                                //re-init the controls
                                app.page.initCheckboxLists();
                                app.input.initSelectMany(document);
                                app.input.initTextEditor(document);
                                $("[data-clear-licenses]").on("click keyup", function () {
                                    //Get the target
                                    clearLicenseList("[data-clear-licenses]");

                                });
                                $('[data-role~="datepicker"]').datepicker();
                            });
                    }
                }

                function clearLicenseList(name) {
                    var target = $(name).data("clear-licenses");
                    //uncheck all checkboxes            
                    $("[name='" + target + "']").prop("checked", false);
                    //trigger change to reset selected list on select many
                    $("[name='" + target + "']").change();
                }

              
            },
            View: function () {
                $('[data-role="applicant-save-vacancy"]').on('click', function () {
                    //have the icon determine the state
                    var icon = $(this).find('i');
                    var shouldSave = false;
                    if ($(icon).hasClass('fa-star-o')) {
                        //clicked with empty star means we need to save it!
                        shouldSave = true;
                    }
                    //udpate database
                    $.post($(this).data('url'), { id = app.page.id, save = shouldSave })
                        .done(function () {
                            //update the ui
                            if ($(icon).hasClass('fa-star')) {
                                //clicked with a filled in star means we need to unsave it!
                                $(icon).removeClass('fa-star');
                                $(icon).addClass('fa-star-o');
                            }
                            else {
                                //clicked with empty star means we need to save it!
                                shouldSave = true;
                                $(icon).addClass('fa-star');
                                $(icon).removeClass('fa-star-o');
                            }
                            //notify user
                            toastr.success("Vacancy saved successfully.");
                        })
                        .fail(function () { toastr.error("Vacancy did not save correctly. Please try again."); });
                });
            }
        };

        return vacancy;
    }()
);